export const getColumnWidths = (columns) =>
  columns.map((column) => ({ columnName: column.name, width: column.width }));
